export default "__VITE_ASSET__BY0PbHtL__"